import React from "react";
import {useState} from "react";
import { Link } from 'react-router-dom'

import { withStyles } from 'tss-react/mui';
import {Backdrop, Paper, Box, Button, Snackbar, Container, Typography} from '@mui/material';

import Terms from '../TermsFamily';
import { authenticationService } from "../services/auth_service";

  const useStyles = (theme, props) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    text: {
      marginTop: theme.spacing(0.8),
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 100,
      color: '#fff',
    },
  });


    function Termo({updateAcceptTerms, userData, classes}){
      
      const [state, setState] = useState({
          openClose : true,
          openEdit: false,
          message: "É necessário aceitar os termos de uso para prosseguir"

      })

      const handleAcceptClick = () => {
        updateAcceptTerms()
        authenticationService.requestGovLoginURL()
        .then(response =>{
          if (response.status === 200){
            window.location.href = response.data.auth_url
          }
        })
        .catch( error => {
          console.log(error)
        })


      }

      const handleNotAcceptClick = () => {
        alert("é necessário aceitar os termos de uso")
        authenticationService.logoutFamilias(userData)

      }
        return(
        <Container>
        <Backdrop className={classes.backdrop} open={true}>
            <Paper>
              <Container component="main" maxWidth="xs" className={classes.paper}>
                  <Terms />
                <Box className={classes.form} method="post">
                  <Typography variant="caption"><Link to="./guide/TermoUsoSoftwareFamilias_VAgo2025.pdf" target="_blank">Termo de Uso Familias - Sistema e-TesteDoPezinho</Link></Typography>
                  <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={handleAcceptClick}>Li e aceito</Button>
                  <Button fullWidth variant="contained" className={classes.cancelButton} onClick={handleNotAcceptClick}>Não aceito</Button>         
                </Box>
                <Snackbar className={classes.alertMessage} open={state.openClose} autoHideDuration={3000} onClose={e => setState({...state, openClose: false })} message={state.message} />
              </Container>
            </Paper>
        </Backdrop>
        </Container>
        )



    }

export default withStyles(Termo, useStyles);